import { render, staticRenderFns } from "./CouponDrawer.vue?vue&type=template&id=124f96ee&lang=pug"
import script from "./CouponDrawer.vue?vue&type=script&lang=coffee"
export * from "./CouponDrawer.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports